export default "__VITE_ASSET__CcmBjs3T__"